export const themeColors = {
  titleColor: "#777777",
  titleTextColor: "#EEEEEE",
  optionColor: "#333333",
  optionTextColor: "#EEEEEE",
  contentColor: "#555555",
  contentTextColor: "#EEEEEE",
  borderColor: "#AAAAAA",
  transparentBlack: "#00000080",
  transparentWhite: "#FFFFFF80",
  windowBackground: "#AAAAAA",
  backgroundTheme: "#444444",
  foregroundTheme: "#EEEEEE",
  red: "#D45548",
  green: "#48D465 ",
  yellow: "#D0D448",
};

export const UserTypes = {
  IND: 0,
  DEV: 1,
  ORG: 2,
};

export const FileTypes = {
  TXT: 0,
  IMG: 1,
  VID: 2,
  AUD: 3,
  XML: 4,
  JS: 5,
  CSS: 6,
  PPT: 7,
  DOC: 8,
  XLS: 9,
  UNKNOWN: 10,
};

export const ExtMap = {
  txtExts: ["txt", "log", "rtf"],
  imgExts: ["jpg", "jpeg", "png", "gif", "pdf", "raw"],
  vidExts: ["mp4", "m4v", "avi", "webm", "wav"],
  audExts: ["mp3"],
  xmlExts: ["xml", "htm", "html"],
  jsExts: ["js", "jsx", "ts"],
  cssExts: ["css", "scss"],
  pptExts: ["ppt", "pptx"],
  docExts: ["doc", "docx"],
  xlsExts: ["xls", "xlsx"],
  otherExts: [],
};

export const googleAPI = {
  API_KEY: "AIzaSyAgZDhfr8kDvpZxhupSWsVz2dRFpWXw7UE",
  CLIENT_ID:
    "694420543975-2o5hqp8h6nc67ggejq4p2gjsr60i7ir6.apps.googleusercontent.com",
};

export const DEFAULT_LOCAL_UID = "LOCAL";
